import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import {ListItemIcon, Tooltip} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";

export default function ListItemButtonsElm({open, label, icon, route, submenu}) {
    const navigate = useNavigate();

    const path = useLocation();
    const labelUrl = path.pathname.split('/')[1].toLowerCase();

    function handleNavigate(selected) {
        navigate(`/${selected}`)
    }

    return (
        <ListItemButton onClick={() => {
            handleNavigate(route)
        }} selected={route === labelUrl}
                        sx={{
                            px: open ? 2 : 1.75,
                            py: 0.5,
                            margin: '0.5rem',
                            width: 'calc(100% - 1rem)',
                            height: '45px',
                            "&.Mui-selected": {
                                backgroundColor: "rgba(255,255,255,0.1)",
                                borderRadius: '10px',
                                "&:hover": {
                                    backgroundColor: "rgba(255,255,255,.04)",
                                }
                            },
                        }}
        >
            <ListItemIcon
                sx={{
                    display: open ? 'none' : 'inline-flex',
                    color: 'rgba(255, 255, 255, 0.75)',
                    minWidth: '42px',
                }}
            >
                <Tooltip title={label} placement="right">
                    {icon}
                </Tooltip>
            </ListItemIcon>
            <ListItemText
                primary={label}
                sx={{
                    display: {
                        xs: 'inline-block',
                        md: open ? 'inline-block' : 'none',
                    },
                    color: 'white',
                }}
            />
        </ListItemButton>
    )
}